import { configureStore } from "@reduxjs/toolkit";
import climateAssistantReducer from "../store/slices/ClimateAssistantSlice";
import sessionManagementReducer from "../store/slices/sessionSlice";
import GlobalSearchReducer from "./slices/GlobalSearchSlice";

export const store = configureStore({
  reducer: {
    climateAssistant: climateAssistantReducer,
    sessionManager: sessionManagementReducer,
    globalSearch: GlobalSearchReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
